import { useCreateOperator } from '../../../../../contexts/CreateOperatorContext';
import { SettingRow } from '../../../../Manage/Operator/Settings/SettingRow';
import { Switch } from '../../../../../components/Switch';
import { Divider } from '../../../../../components/Divider';
import { SettingTag } from '../../SettingTag';
import { AppKeys } from './AppKeys';
import React from 'react';
import { useSort } from '../../../../../hooks/useSort';

export const MediaroomSettings = () => {
  const { operator, loading, updateOperator } = useCreateOperator();
  const { sortAsc } = useSort<{ order: number }>('order');

  if (operator.mediaRoomSettings === undefined) return null;

  const tag = <SettingTag name="Mediaroom" color="violet" size="sm" />;

  const settings: SettingRowConfig[] = [
    {
      order: 1,
      component: (
        <Switch
          disabled={loading}
          checked={operator.mediaRoomSettings.useScreensaver}
          onChange={(event) =>
            updateOperator(
              'mediaRoomSettings',
              Object.assign(operator.mediaRoomSettings!, {
                useScreensaver: event.target.checked,
              })
            )
          }
        />
      ),
      title: 'Uses Screensaver',
      description:
        'Enable or disable the default screensaver setting in the Mediaroom Client',
      icon: tag,
      level: 'sub',
      show: true,
    },
    {
      order: 2,
      component: (
        <Switch
          disabled={loading}
          checked={
            operator.mediaRoomSettings?.showSubscribedChannelsOnly ?? false
          }
          onChange={(event) =>
            updateOperator(
              'mediaRoomSettings',
              Object.assign(operator.mediaRoomSettings!, {
                showSubscribedChannelsOnly: event.target.checked,
              })
            )
          }
        />
      ),
      title: 'Subscribed Channels Only',
      description:
        'Enable or disable the show subscribed channels only setting in the Mediaroom Client',
      icon: tag,
      level: 'sub',
      show: true,
    },
  ];

  const renderDivider = (index: number) => {
    if (index + 1 === settings.filter((setting) => setting.show).length) return;
    return <Divider />;
  };

  return (
    <>
      <Divider />
      {settings
        .filter((setting) => setting.show)
        .sort(sortAsc)
        .map((setting, index) => (
          <React.Fragment key={`operator-mediaroom-setting-${index + 1}`}>
            <SettingRow
              title={setting.title}
              description={setting.description}
              icon={setting.icon}
              level={setting.level}
            >
              {setting.component}
            </SettingRow>
            {renderDivider(index)}
          </React.Fragment>
        ))}
      <AppKeys />
    </>
  );
};
